import {
  JSResource,
  type SimpleEntryPoint,
} from "@loop-payments/react-router-relay";
import type { ItemsOverview } from "./ItemsOverview";
import ItemsOverviewQueryNode from "./__generated__/ItemsOverviewQuery.graphql";

const entryPoint: SimpleEntryPoint<typeof ItemsOverview> = {
  root: JSResource("ItemsOverview", () =>
    import("./ItemsOverview").then((module) => module.ItemsOverview),
  ),
  getPreloadProps() {
    return {
      queries: {
        query: {
          parameters: ItemsOverviewQueryNode,
          variables: {},
          options: {
            fetchPolicy: "store-and-network",
          },
        },
      },
    };
  },
};

export default entryPoint;
